
import Vue from "vue";
export default Vue.extend({
	data(){
		return {
			isDragging: false,
			dragStartX: 0,
			currentX: 0,
			startWidth: 0
		};
	},
	props: {
		name: {
			type: String,
			required: true
		},
		alignRight: Boolean,
		storedWidths: {
			type: Object as ()=>{[key:string]:number},
			required: true
		},
		minimumWidths: {
			type: Object as ()=>{[key:string]:number},
			required: true
		},
		afterDescription: Boolean
	},
	computed: {
		width():string{
			if (this.isDescription){
				return `calc(100% - ${this.getTotalWidthWithoutDescription()}px)`;
			}
			if (this.isDragging) {
				return `${Math.max(this.dragWidth, this.minimumWidths[this.name] || 0)}px`;
			}
			return `${this.storedWidths[this.name] || 80}px`;
		},
		maxTextWidth():string{
			let offset = 25;
			if (this.isDescription){
				if (!this.$el) return "";
				let width = this.$el.getBoundingClientRect().width;
				return `${width-offset}px`;
			}
			if (this.isDragging) {
				return `${Math.max(this.dragWidth, this.minimumWidths[this.name] || 0) - offset}px`;
			}
			return `${(this.storedWidths[this.name] || 80) - offset}px`;
		},
		isDescription():boolean {
			return this.name == "description";
		},
		dragWidth():number{
			let width = this.startWidth + (this.currentX - this.dragStartX);
			if (this.afterDescription) {
				width = this.startWidth - (this.currentX - this.dragStartX);
			}
			if (this.minimumWidths[this.name] && this.minimumWidths[this.name] > width){
				width = this.minimumWidths[this.name];
			}
			return width;
		}
	},
	methods: {
		getTotalWidthWithoutDescription():number {
			return Object.keys(this.storedWidths).map((key)=>this.storedWidths[key]).reduce((prevVal, currentVal)=>prevVal+currentVal);
		},
		onAnchorMouseDown(e:MouseEvent){
			this.isDragging = true;
			this.startWidth = this.storedWidths[this.name] || 80;
			this.currentX = e.pageX;
			this.dragStartX = e.pageX;
			document.body.onselectstart = ()=>false;
		},
		onMouseMove(e:MouseEvent){
			if (!this.isDragging) return;
			this.currentX = e.pageX;
			this.storedWidths[this.name] = Math.max(this.dragWidth, this.minimumWidths[this.name] || 0);
		},
		onMouseUp(){
			if (!this.isDragging) return;
			this.isDragging = false;
			this.storedWidths[this.name] = Math.max(this.dragWidth, this.minimumWidths[this.name] || 0);
			document.body.onselectstart = null;
		}
	},
	created(){
		window.addEventListener("mouseup", this.onMouseUp);
		window.addEventListener("mousemove", this.onMouseMove);
	},
	destroyed(){
		window.removeEventListener("mouseup", this.onMouseUp);
		window.removeEventListener("mousemove", this.onMouseMove);
	}
});
